import React from 'react';
import ImageSucces from '../../../../assets/images/image-success.png'; 
import { useHistory } from 'react-router-dom';
import { goTo } from '../../../../utils/moveTo';
import useLangTranslation from '../../../customHooks/languageProvider';

const Success = ({ successMsg, redirectTo = '' }) => {
    const history = useHistory();
    const { getLangTranslation } = useLangTranslation();
    return (
        <div className="container">
            <div className="auth-wrapper">
                <div className="auth-inner text-center">
                    <div>
                        <img src={ImageSucces} alt='' />
                    </div>
                    <h5 className="text-center mb-9">
                        {/* An email was sent to your registered email address <br />with your Pin Code */}
                        {getLangTranslation(successMsg)}
                    </h5>

                    <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={() => goTo(history, redirectTo)}
                    >
                        <span className="btn-upper-case">{getLangTranslation("PIN_CODE_RECOVERY_GOT_IT", "Got it")}</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Success;